const elearningStepsSection = $('#steps-section');
const elearningStepsTitle = elearningStepsSection.find('.section-title');
const elearningStepsCards = elearningStepsSection.find('.step-card');
const elearningStepsButton = elearningStepsSection.find('.button-parent')

const addElearningStepAnimation = () => {
    const sectionInTL = gsap.timeline({paused: true});
    const titleAnimationConfig = {
        offsetPercent: 150,
        opacityStart: 0,
        blurStart: '0px',
        duration: 0.8,
        delay: 0.3,
        stagger: 0.1,
        isDurationCommon: true,
    }

    sectionInTL.add(
        addTitleAnimation({
            element: elearningStepsTitle,
            animationConfig : titleAnimationConfig,
        }).play(),
    );

    sectionInTL.add(elementInAnimationYWOpacity(elearningStepsCards, '300%', 0, 1, 1, 0.8, 0.2, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0);
    addBtnAnimation(elearningStepsButton, 50, true);

    return sectionInTL;
}

const initelearningSteps = () => {

    const elearningStepsTL = addElearningStepAnimation();
    ScrollTrigger.create({
        trigger: elearningStepsSection,
        start: 'top+=30% bottom',
        end: 'top top',
        once: true,
        onEnter: () => {
            elearningStepsTL.play();
        },
    });
}

addSectionObserver(elearningStepsSection, initelearningSteps, false);